const BreadCrumb = ({ breadcrumbURI }: { breadcrumbURI: string }) => (
    <div className="col-lg-3 col-xl-6 col-sm-12 col-xs-12 cursor">
        <h6 className="mt-2 breadcrumb-item  all-color">
            {' '}
            {breadcrumbURI}
            <span className=" mx-1 activelink">Checkout</span>
        </h6>
    </div>
);
export default BreadCrumb;